import MStepperBar from './MStepperBar.vue';

MStepperBar.install = (app) => {
  app.component('MStepperBar', MStepperBar);
};

export { MStepperBar };
